import { render } from "./TargetGroupsPage.vue?vue&type=template&id=5321e92b"
import script from "./TargetGroupsPage.vue?vue&type=script&lang=js"
export * from "./TargetGroupsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__